import React from 'react';
import PropTypes from 'prop-types';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import Tooltip from '@ublend-npm/react-tooltip';
import Analytics from '@ublend-npm/aula-analytics';

import { Link, DisabledLink } from './ExternalLink.styled';
import { looks } from './ExternalLink.variant';
import { CLICK_ASSIGNMENT_EXTERAL_LINK } from '$variables/analyticsEvents';

const ExternalLink = ({
  'data-testid': dataTestId,
  disabledText,
  look,
  onClick,
  to,
}) => {
  const handleClick = (event) => {
    event.stopPropagation();

    if (onClick) {
      event.preventDefault();
      onClick();
    }

    Analytics.track({
      event: CLICK_ASSIGNMENT_EXTERAL_LINK,
      externalLink: to || 'turnitin',
    });
  };

  if (disabledText) {
    return (
      <Tooltip title={disabledText} position="top" spacing={4}>
        <DisabledLink aria-label="Disabled link" data-testid={dataTestId}>
          <OpenInNewIcon fontSize="inherit" />
        </DisabledLink>
      </Tooltip>
    );
  }

  return (
    <Link
      aria-label="Open link in a new tab"
      data-testid={dataTestId}
      href={to}
      look={looks[look]}
      onClick={handleClick}
      target="_blank"
    >
      <OpenInNewIcon fontSize="inherit" />
    </Link>
  );
};

ExternalLink.propTypes = {
  to: PropTypes.string,
  look: PropTypes.string,
  onClick: PropTypes.func,
  disabledText: PropTypes.string,
  'data-testid': PropTypes.string,
};

ExternalLink.defaultProps = {
  look: 'default',
  to: '',
  onClick: undefined,
  disabledText: null,
  'data-testid': undefined,
};

export default ExternalLink;
